import { connect } from 'react-redux';
import ChecklistItemAnswering from './checklistItem-checking';
import {
  selectChecklist,
  onStartChecklist,
  onRemoveChecklistRun,
  onFinishChecklistRun,
} from '../../reducers/checklist.reducers';

import { loadSingleChecklistItem } from '../../reducers/checklistItemGroup.reducers';
import { onSubmitChecklistItemAnswers } from '../../reducers/checklistItem.reducers';

const mapDispatchToProps = (dispatch) => ({
  loadChecklistItem: (id) => dispatch(loadSingleChecklistItem(id)),
  finishChecklistRun: (checklistRun) =>
    dispatch(onFinishChecklistRun(checklistRun)),
  startNewChecklistRun: (checklist) => {
    dispatch(selectChecklist(checklist));
    dispatch(onStartChecklist({ checklistId: checklist.id }));
  },
  removeChecklistRun: (runId) => dispatch(onRemoveChecklistRun(runId)),
  submitChecklist: () => dispatch(onSubmitChecklistItemAnswers()),
});

const mapStateToProps = (state) => ({
  config: state.authentication.config,
  checklistRun: state.checklist.selectedChecklistRun,
  checklistItemGroups: state.checklistItemGroup.checklistItemGroups,
  checklistItems: state.checklistItemGroup.checklistItems,
  classes: state.classes,
  score: state.checklist.score,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChecklistItemAnswering);



// WEBPACK FOOTER //
// ./src/app/components/checklist_checking/checklistItem-checking.container.js